/** Unveränderliche UTF-8-Leseabzüge; keine Annahme historischer Vertragsbytes behauptet. */
export const LEGAL_TERMS_ARCHIVE = {
  "de": {
    "path": "/legal/archive/staysuite-agb-2026-08-18.de.txt",
    "sha256": "20b2d8997d73767c4a433ff251083803f07311d099ce230b591b04240e5b35f3"
  },
  "en": {
    "path": "/legal/archive/staysuite-agb-2026-08-18.en.txt",
    "sha256": "db8be0357cc87748f9067272b71f5d807bffab976ec2d5f4b5cbc4d8ab655963"
  }
} as const
